import React from 'react';

import ListOptionGroup from '../../../../ListOptionGroup/ListOptionGroup';
import { ArrowDownSLineIcon } from '../../../../Icons';

export const EMPTY_LANGUAGE_VALUE = '__EMPTY_VALUE__';

const LANGUAGES = [
    { label: 'JSON', value: 'json', alias: ['json'] },
    { label: 'Markdown', value: 'markdown', alias: ['markdown', 'md'] },
    { label: 'Mermaid', value: 'mermaid', alias: ['mermaid'] },
    { label: 'Plotly', value: 'plotly', alias: ['plotly'] },
    { label: 'Python', value: 'python', alias: ['python'] },
    { label: 'Text', value: EMPTY_LANGUAGE_VALUE, alias: [EMPTY_LANGUAGE_VALUE] },
];
const LANGUAGES_MAPPING = LANGUAGES.reduce(
    (acc, { label, alias }) => ({
        ...acc,
        ...alias.reduce((acc, name) => ({ ...acc, [name]: label }), {}),
    }),
    {}
);

const CodeLanguageSelect = ({
    language,
    disabled = false,
    onChange,
    isLangSelectOpened,
    toggleLangSelect,
}) => {
    const onLanguageChange = (lang) => {
        onChange(lang);
        toggleLangSelect();
    };

    const listOptions = LANGUAGES.map(({ label, value }) => (
        <button
            className="block w-full truncate px-2 py-1.5 rounded-2 bg-white hover:bg-neutral-50 transition-colors font-body text-body-regular-xs text-neutral-500 text-left"
            onClick={() => onLanguageChange(value)}
            key={value}
        >
            {label}
        </button>
    ));

    return (
        <div className="relative">
            <button
                className="pl-2 flex items-center font-body text-body-regular-xs text-neutral-500 select-none"
                disabled={disabled}
                onClick={toggleLangSelect}
            >
                {LANGUAGES_MAPPING[language]}{' '}
                {!disabled && <ArrowDownSLineIcon width={14} height={12} color="#1F2125" />}
            </button>

            {isLangSelectOpened && (
                <div className="absolute top-[110%] right-0 z-30">
                    <ListOptionGroup
                        fixedWidth={189}
                        listOptions={listOptions}
                        additionalStyles="!p-2"
                        handleClose={toggleLangSelect}
                    ></ListOptionGroup>
                </div>
            )}
        </div>
    );
};

export default CodeLanguageSelect;
